import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ApiService } from 'src/app/services/api.service';
import { NotifyService } from 'src/app/services/notify.service';
import { ValueService } from 'src/app/services/value.service';
import { environment } from 'src/environments/environment';
import { EventAddComponent } from '../event-add/event-add.component';
import { RemarksComponent } from '../../remarks/remarks.component';
import { MatDialog } from '@angular/material/dialog';
declare let $: any;
@Component({
  selector: 'app-event-list',
  templateUrl: './event-list.component.html',
  styleUrls: ['./event-list.component.css'],
})
export class EventListComponent implements OnInit {
  displayedColumns: string[] = [
    'index',
    'eventName',
    'eventFromDate',
    'eventFromTime',
    'incubatorName',
    'remarks',
    'status',
    'action',
  ];
  dataSource: MatTableDataSource<any>;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  private listApi = environment.url + environment.eventList;
  private deleteApi = environment.url + environment.eventDelete;
  /**
   * Constructor to inject necessary services
   * @param makeapi Service for API calls
   * @param getdata Service for value management
   * @param notify Service for notifications
   * @param dialog Service for dialog management
   */
  constructor(
    private makeapi: ApiService, // Handles API requests
    private getdata: ValueService, // Manages application values
    private notify: NotifyService, // Manages notifications
    public dialog: MatDialog // Manages dialogs
  ) {
    this.dataSource = new MatTableDataSource(); // Initializes the data source for the table
  }

  roleValue;
  /**
   * Initializer for the component
   * Called when the component is loaded
   */
  ngOnInit(): void {
    // Show the content of the page
    this.getdata.isVisibleSource.next(true);
    // Get the role of the user
    this.roleValue = sessionStorage.getItem('role');
    // Add the class to the button
    $('.all').addClass('btnActive');
    // Set the default value for the status
    this.valueGet = 'all';
    // Call the function to get the data
    this.ststusBtn(3, 'all');
  }

  list = {};
  disList: any = [];
  pageTotalCount: number;
  pageSize: number = 25;
  pageNumber: number = 1;
  noData = true;
  /**
   * Event list function
   * Gets the list of events based on the filter and pagination
   */
  eventList() {
    // Set the list of parameters
    this.list = {
      listSize: this.pageSize,
      pageNumber: this.pageNumber,
      // Filter by the selected status
      status: this.valueGet,
    };
    // Call the function to get the data
    this.ListApi();
  }
  /**
   * Function to get the list of events
   * Subscribes to the API response and updates the component data
   */
  ListApi() {
    return this.makeapi
      .method(this.listApi, this.list, 'post')
      .subscribe((data) => {
        // If there is no data, set the noData flag to true
        if (data.count == 0) {
          this.noData = true;
        }
        // If there is data, set the noData flag to false and update the component data
        else {
          this.noData = false;
          this.pageTotalCount = data.count;
          this.disList = data.responsemodelList;

          this.dataSource = new MatTableDataSource(data.responsemodelList);
        }
      });
  }
  /**
   * Set the paginator for the data source
   * This is needed to perform server-side pagination
   */
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  /**
   * Apply a filter to the data source based on the input event
   * @param event - The input event containing the filter value
   */
  applyFilter(event: Event) {
    // Get the filter value from the event target and convert it to lowercase
    const filterValue = (event.target as HTMLInputElement).value;
    // Apply the trimmed and lowercased filter value to the data source
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
  /**
   * Handles the pagination events
   * Updates the component data based on the current page index and page size
   * @param event - The pagination event containing the page index and page size
   */
  getServerData(event) {
    // Update the page number and page size
    this.pageNumber = event.pageIndex + 1;
    this.pageSize = event.pageSize;
    // If the selected value is not 3, add the status to the list
    if (this.valueGet != 3) {
      this.list = {
        listSize: this.pageSize,
        pageNumber: this.pageNumber,
        status: this.valueGet,
      };
    }
    // If the selected value is 3, do not add the status to the list
    else {
      this.list = {
        listSize: this.pageSize,
        pageNumber: this.pageNumber,
      };
    }
    // Call the API to get the updated data
    this.ListApi();
  }
  /**
   * Opens a dialog to add a new event
   * @param value - The title of the event to be added
   */
  eventAddBtn(value) {
    // Open the EventAddComponent dialog with the provided title
    const dialogRef = this.dialog.open(EventAddComponent, {
      data: { title: value },
    });

    // After the dialog is closed, refresh the event list
    dialogRef.afterClosed().subscribe((result) => {
      this.ListApi();
    });
  }
  /**
   * Opens a dialog to edit an existing event
   * @param value - The title of the event to be edited
   * @param id - The ID of the event to be edited
   */
  editEvent(value, id) {
    // Open the EventAddComponent dialog with the provided title and ID
    const dialogRef = this.dialog.open(EventAddComponent, {
      data: { title: value, _id: id },
    });

    // After the dialog is closed, refresh the event list
    dialogRef.afterClosed().subscribe((result) => {
      this.ListApi();
    });
  }
  /**
   * Deletes an event
   * @param id - The ID of the event to be deleted
   */
  deleteEvent(id: string): void {
    // Delete the event by making a POST request to the delete API
    const getdata = [id];
    this.makeapi
      .method(this.deleteApi, getdata, 'post')
      .subscribe((data: any) => {
        // If the response status is 'Success', show a success message and refresh the list
        if (data.responseStatus == 'Success') {
          this.notify.notifysuccess(data.responseMessage);
          this.ListApi();
        } else {
          // Otherwise, show an error message
          this.notify.notifyError(data.responseMessage);
        }
      });
  }
  /**
   * Opens a dialog to view the description details.
   * @param status - The status associated with the description.
   * @param title - The title of the description.
   */
  viewDescrptionBtn(status, title) {
    // Open the RemarksComponent dialog with the provided status and title
    const dialogRef = this.dialog.open(RemarksComponent, {
      width: '390px',
      data: { _status: status, _title: title },
    });

    // After the dialog is closed, perform any necessary actions
    dialogRef.afterClosed().subscribe((result) => {
      // Handle any logic after the dialog is closed
    });
  }

  /**
   * Redirects to the incubatee event page
   * @param id - The ID of the incubatee event
   */
  incubateeEvent(id: string): void {
    // Redirect to the incubatee event page by calling the eventId method and passing the base64 encoded ID
    this.getdata.eventId(btoa(id));
  }
  valueGet;
  butActClass;
  /**
   * Changes the status of the event list and updates the list by calling ListApi()
   * @param value - The status of the event
   * @param name - The class name associated with the status button
   */
  ststusBtn(value, name) {
    // Set the page size to 25 records per page
    this.pageSize = 25;

    // Remove the active class from all status buttons
    $('.all').removeClass('btnActive');

    // Store the status value
    this.valueGet = value;

    // Remove the active class from the current status button
    $(this.butActClass).removeClass('btnActive');

    // Store the class name of the current status button
    this.butActClass = '.' + name;

    // Add the active class to the current status button
    $(this.butActClass).addClass('btnActive');

    // If the status is not 3, add the status to the list
    if (value != 3) {
      this.list = {
        listSize: this.pageSize,
        pageNumber: this.pageNumber,
        status: this.valueGet,
      };
    } else {
      // Otherwise, do not add the status to the list
      this.list = {
        listSize: this.pageSize,
        pageNumber: this.pageNumber,
      };
    }

    // Call ListApi() to update the list
    this.ListApi();
  }
}
